import { render, staticRenderFns } from "./CvModal.vue?vue&type=template&id=5372486f"
import script from "./CvModal.vue?vue&type=script&lang=ts"
export * from "./CvModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports